exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3ma1EOroZdHtgU{padding-bottom:24px}", ""]);

// exports
exports.locals = {
	"linkSection": "_3ma1EOroZdHtgU"
};